var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "div",
        {
          staticClass: "modal-container show",
          style: { zIndex: _vm.Ioptions.zIndex },
        },
        [
          _c("div", { staticClass: "modal-overlay" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal",
              class: _vm.Ioptions.type,
              style: _vm.forcedSize,
            },
            [
              _c("div", { staticClass: "header" }, [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.Ioptions.title) },
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "zmdi zmdi-close close",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.hide($event)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "container-fluid scroll" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.Ioptions.content
                        ? _c("div", {
                            staticClass: "col-12 confirm-content",
                            domProps: {
                              innerHTML: _vm._s(_vm.Ioptions.content),
                            },
                          })
                        : _c(
                            _vm.Ioptions.content_component,
                            _vm._b(
                              { tag: "component" },
                              "component",
                              _vm.Ioptions.content_component_props,
                              false
                            )
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.Ioptions.doubleConfirm
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "col-12 simple-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.doubleConfirmAccept,
                                  expression: "doubleConfirmAccept",
                                },
                              ],
                              attrs: { type: "checkbox", id: "doubleConfirm" },
                              domProps: {
                                checked: Array.isArray(_vm.doubleConfirmAccept)
                                  ? _vm._i(_vm.doubleConfirmAccept, null) > -1
                                  : _vm.doubleConfirmAccept,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.doubleConfirmAccept,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.doubleConfirmAccept = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.doubleConfirmAccept = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.doubleConfirmAccept = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "doubleConfirm" } }, [
                              _vm._v(_vm._s(_vm.Ioptions.doubleConfirmMessage)),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "Toolbar",
                { staticClass: "not-fixed" },
                [
                  _c(
                    "Btn",
                    {
                      staticClass: "primary",
                      class: [
                        _vm.Ioptions.type,
                        {
                          disabled:
                            _vm.Ioptions.doubleConfirm &&
                            !_vm.doubleConfirmAccept,
                        },
                      ],
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.accept($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.Ioptions.yesButtonText
                              ? _vm.Ioptions.yesButtonText
                              : _vm.$t("global.yes")
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "Btn",
                    {
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.decline($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.Ioptions.noButtonText
                              ? _vm.Ioptions.noButtonText
                              : _vm.$t("global.no")
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }